import React from "react";
import { Box, Skeleton } from "@mui/material";
import { colorSystem } from "../../theme";

export default function ClientNutritionListSkeleton() {
  return (
    <>
      <Box
        sx={{ width: "100%", backgroundColor: colorSystem.white2, padding: 2 }}
      >
        <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
          {Array.from({ length: 5 }).map(() => (
            <Skeleton sx={{ width: "100%" }} />
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: 2,
          padding: 2,
        }}
      >
        {Array.from({ length: 3 }).map(() => (
          <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
            {Array.from({ length: 5 }).map(() => (
              <Skeleton sx={{ width: "100%" }} />
            ))}
          </Box>
        ))}
      </Box>
    </>
  );
}
